import { useEffect, useState } from "react";
import ButtonComponent from "../button";
import InputComponent from "../input";
import ReportCatalogFiltersComponent from "../report-catalog-filters";
import TabsComponent from "../tabs";
import { useDispatch, useSelector } from "react-redux";
import { providerInstitutionConstant, statusOptions } from "../../constants/user-constants";
import { ReportCatalogFiltersContainer, ReportCatalogFiltersHead, ReportCatalogFormats, TableWrapper, EmptyWrapper, ActionsContainer, FormError } from "../../pages/report-catalog/report-catalog.style";
import { DownloadSvg, LoaderSvg, PlaySvg, ReloadSvg, SettingsSvg } from "../../assets/svgs";
import { getAllParticipantExportHistoryData, getAllParticipantExportModuleData, getSpecificParticipantHistoryData } from "../../redux/slices/report-catalog-slice";
import { ReportCatalogAvailableFormats, ReportCatalogAvailableTabs, ReportCatalogFormatsConstant, ReportCatalogTabsConstant } from "../../pages/report-catalog/report-catalog.constants";
import TableComponent from "../table";
import moment from "moment";
import { AnchorButton } from "../../styles/global-styles";
import { toast } from "react-toastify";
import { exportReportToCSV, exportReportToExcel, exportReportToPDF } from "../../helpers";
import BadgeComponent from "../badge";
import { Alert } from "@mui/material";

const ParticipantManagementReportExport = () => {
    const dispatch = useDispatch();

    const { isLoading: isGlobalApiLoading } = useSelector((state) => state.globalLoadingReducer);
    const { user } = useSelector((state) => state.loginUserReducer);
    const { exportData: { participant: { loading, data: reportExportData, history } } , specificLoading } = useSelector((state) => state.ReportCatalogReducer);
    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);

    const columnMapping = {
        'institutionId': 'Institution ID',
        'institutionName': 'Institution',
        'primaryPersonName': 'Primary Person Name',
        'primaryPersonEmail': 'Primary Person Email',
        'primaryPersonPhone': 'Primary Person Phone',
        'secondaryPersonName': 'Secondary Person Name',
        'secondaryPersonEmail': 'Secondary Person Email',
        'secondaryPersonPhone': 'Secondary Person Phone',
        'institutionStatus': 'Status',
        'otpCharacteristics': 'OTP Characteristics',
        'deliveryType': 'Delivery Type',
        'otpValidityTime': 'OTP Validity Time',
        'createdDatetime': 'Created At',
    };

    const initialStates = {
        tabs: ReportCatalogAvailableTabs,
        formats: ReportCatalogAvailableFormats,
        selectedTab: ReportCatalogAvailableTabs?.[0]?.value,
        selectedHistory: null,
        search: {
            institutionName: isProvider ? undefined : (user?.institution?.label || undefined),
        },
    };

    const initialForm = {
        reportName: 'Participant Management Report',
        reportNameError: null,
        selectedFormat: ReportCatalogAvailableFormats?.[0],
    };

    const [states, setStates] = useState(initialStates);
    const [form, setForm] = useState(initialForm);

    const handleChangeForm = (e) => {
        const { name, value, type, checked } = e.target
        setForm((old) => ({
            ...old,
            [name]: ['checkbox', 'radio'].includes(type) ? checked : value
        }));
    };

    const handleChangeFilters = (e) => {
        const { name, value, type, checked } = e.target
        setStates((old) => ({
            ...old,
            search: ({
                ...old.search,
                [name]: ['checkbox', 'radio'].includes(type) ? checked : value
            })
        }));
    };

    const handleReset = () => {
        setStates(initialStates);
        setForm(initialForm);
    };

    const HandleGenerateReport = (e) => {
        e.preventDefault();

        // if (!selectedModule || !form?.selectedFormat || !states?.search) return;

        // if (form?.reportNameError) return;

        const { fromDate, toDate } = states?.search || {};

        if (fromDate || toDate) {
            if (!fromDate) {
                return toast.error("Please select From Date");
            }
            if (!toDate) {
                return toast.error("Please select To Date");
            }
            if (moment(fromDate).isAfter(toDate)) {
                return toast.error("From Date cannot be after To Date");
            }
        }

        const params = {
            format: form?.selectedFormat || ReportCatalogAvailableFormats?.[0],
            reportFilter: states?.search || {},
        };

        dispatch(getAllParticipantExportModuleData({ user, params }))
            .then((action) => {
                if (action?.payload && action?.payload?.length > 0) {
                    // setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.preview, search: null }));
                    setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.preview }));
                } else {
                    toast.error("No data found to export!");
                }

                if (action?.meta?.requestStatus === "fulfilled") {
                    dispatch(getAllParticipantExportHistoryData({ user }));
                }
            })
            .catch((error) => {
                toast.error("Failed to retrieve data");
            });
    };

    const handleExportReport = () => {
        if (reportExportData && reportExportData?.length > 0) {
            const fileData = {
                name: form?.reportName,
                list: reportExportData,
            };

            if (form?.selectedFormat === ReportCatalogFormatsConstant?.xlsx) {
                exportReportToExcel(fileData, columnMapping);
            } else if (form?.selectedFormat === ReportCatalogFormatsConstant?.csv) {
                exportReportToCSV(fileData, columnMapping);
            } else if (form?.selectedFormat === ReportCatalogFormatsConstant?.pdf) {
                exportReportToPDF(fileData, columnMapping);
            }
        } else {
            toast.info("No data available to export");
        }
    };

    const handleSpecificDownload = (row) => {
        // setStates((old) => ({ ...old, selectedHistory: { ...row, loading: true } }));

        dispatch(getSpecificParticipantHistoryData({ user, id: row?.exportId }))
            .then((action) => {
                // setStates((old) => ({ ...old, selectedHistory: null }));

                if (action?.meta?.requestStatus === "fulfilled") {
                    if (action?.payload && action?.payload?.length > 0) {
                        const fileData = {
                            name: form?.reportName,
                            list: action?.payload,
                        };

                        if (row?.fileFormat === ReportCatalogFormatsConstant?.xlsx) {
                            exportReportToExcel(fileData, columnMapping);
                        } else if (row?.fileFormat === ReportCatalogFormatsConstant?.csv) {
                            exportReportToCSV(fileData, columnMapping);
                        } else if (row?.fileFormat === ReportCatalogFormatsConstant?.pdf) {
                            exportReportToPDF(fileData, columnMapping);
                        }
                    } else {
                        toast.error("No data found to download!");
                    }
                }
            });
    };

    useEffect(() => {
        if (user) {
            dispatch(getAllParticipantExportHistoryData({ user }));
        }
    }, [user, dispatch]);

    useEffect(() => {
        if (form?.reportName && form?.reportName?.trim()?.length > 129) {
            setForm((old) => ({ ...old, reportNameError: "Report name must be no more than 130 characters." }));
        } else {
            setForm((old) => ({ ...old, reportNameError: null }));
        }
    }, [form?.reportName]);

    const searchFields = [
        {
            label: 'From Date',
            type: 'date',
            placeholder: 'Select start date',
            name: 'fromDate',
            value: states?.search?.fromDate || '',
        },
        {
            label: 'To Date',
            type: 'date',
            placeholder: 'Select end date',
            name: 'toDate',
            value: states?.search?.toDate || '',
        },
        // {
        //     label: 'Created At',
        //     type: 'date',
        //     placeholder: 'Search by date',
        //     name: 'createdDate',
        //     value: states?.search?.createdDate || '',
        // },
        ...(isProvider ? [{
            label: 'Institution',
            type: 'text',
            placeholder: 'Search by Name',
            name: 'institutionName',
            value: states?.search?.institutionName || '',
        }] : []),
        {
            label: 'Status',
            type: 'select',
            options: statusOptions?.map(({ label }) => ({ label, value: label })) || [],
            name: 'institutionStatus',
            value: states?.search?.institutionStatus || '',
        },
    ];

    const columns = [
        { field: 'institutionId', headerName: 'Institution ID', width: 150, align: 'center' },
        { field: 'institutionName', headerName: 'Institution', width: 150, align: 'center' },
        { field: 'primaryPersonName', headerName: 'Primary Person Name', width: 150, align: 'center' },
        { field: 'primaryPersonEmail', headerName: 'Primary Person Email', width: 150, align: 'center' },
        { field: 'primaryPersonPhone', headerName: 'Primary Person Phone', width: 160, align: 'center' },
        { field: 'secondaryPersonName', headerName: 'Secondary Person Name', width: 170, align: 'center' },
        { field: 'secondaryPersonEmail', headerName: 'Secondary Person Email', width: 150, align: 'center' },
        { field: 'secondaryPersonPhone', headerName: 'Secondary Person Phone', width: 170, align: 'center' },
        {
            field: 'institutionStatus', headerName: 'Status', width: 140, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.institutionStatus &&
                            <BadgeComponent
                                label={row?.institutionStatus}
                                type={row?.institutionStatus?.toLowerCase()?.includes('in') ? 'warning' : 'success'}
                            />
                        }
                    </>
                )
            },
            sortBy: (row) => row?.institutionStatus,
        },
        { field: 'otpCharacteristics', headerName: 'OTP Characteristics', width: 150, align: 'center' },
        {
            field: 'deliveryType', headerName: 'Delivery Type', width: 150, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.deliveryType &&
                            <BadgeComponent
                                label={row?.deliveryType}
                            // outline
                            />
                        }
                    </>
                )
            },
            sortBy: (row) => row?.deliveryType,
        },
        { field: 'otpValidityTime', headerName: 'OTP Validity Time', width: 200, align: 'center' },
        {
            field: 'createdDatetime', headerName: 'Created At', width: 180, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {row?.createdDatetime && moment(row?.createdDatetime).format('lll')}
                    </>
                )
            },
            sortBy: (row) => row?.createdDatetime,
        },
    ];

    const historyColumns = [
        { field: 'exportId', headerName: 'Export ID', width: 150, align: 'center' },
        {
            field: 'fileFormat', headerName: 'File Format', width: 120, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.fileFormat &&
                            <BadgeComponent
                                label={row?.fileFormat?.toUpperCase()}
                                type={{
                                    [ReportCatalogFormatsConstant?.xlsx]: 'success',
                                    [ReportCatalogFormatsConstant?.pdf]: 'error',
                                }[row?.fileFormat] || 'default'}
                            />
                        }
                    </>
                )
            },
            sortBy: (row) => row?.fileFormat,
        },
        { field: 'rowCount', headerName: 'Row Count', width: 150, align: 'center' },
        {
            field: 'generatedOn', headerName: 'Generated On', width: 180, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {row?.generatedOn && moment(row?.generatedOn).format('lll')}
                    </>
                )
            },
            sortBy: (row) => row?.generatedOn,
        },
        { field: 'expires', headerName: 'Expires', width: 100, align: 'center' },
        {
            field: 'action', headerName: 'Action', width: 140, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.rowCount > 0 &&
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <AnchorButton onClick={() => handleSpecificDownload(row)} disabled={specificLoading !== null}>
                                    {
                                        row?.exportId === specificLoading ?
                                            <LoaderSvg />
                                            :
                                            <DownloadSvg />
                                    }
                                    <span>{row?.exportId === specificLoading ? "Downloading..." : "Download"}</span>
                                </AnchorButton>
                            </div>
                        }
                    </>
                )
            },
            sortable: false,
        },
    ];

    return (
        <TabsComponent
            // bgColor="#eaf5fe"
            onChange={(value) => setStates((old) => ({ ...old, selectedTab: value }))}
            tabs={states.tabs}
            value={states.selectedTab}
            heightfull
        >
            <>
                {
                    states.selectedTab === ReportCatalogTabsConstant?.filters &&
                    <ReportCatalogFiltersContainer>
                        <ReportCatalogFiltersHead>
                            <h4>Report Configuration</h4>
                            {
                                states?.formats && states?.formats?.length > 0 &&
                                <ReportCatalogFormats>
                                    {

                                        states?.formats?.map((format, index) => (
                                            <div
                                                key={index}
                                                className={form?.selectedFormat === format ? 'active' : ''}
                                                onClick={() => setForm((old) => ({ ...old, selectedFormat: format }))}
                                            >
                                                {format}
                                            </div>
                                        ))
                                    }
                                </ReportCatalogFormats>
                            }
                        </ReportCatalogFiltersHead>
                        <div>
                            <InputComponent
                                label='Report Name'
                                type='text'
                                placeholder='Enter report name'
                                name='reportName'
                                value={form?.reportName || ''}
                                onChange={handleChangeForm}
                                mui
                                inputProps={{ maxLength: 130 }}
                            />
                            {
                                form?.reportNameError &&
                                <FormError>{form?.reportNameError}</FormError>
                            }
                        </div>
                        <div>
                            <p style={{ margin: '0 0 5px 0' }}>Filters</p>
                            <ReportCatalogFiltersComponent
                                open={true}
                                searchFields={searchFields}
                                handleChange={handleChangeFilters}
                                handleSubmit={HandleGenerateReport}
                                cols={3}
                            />
                        </div>
                        <ActionsContainer>
                            <ButtonComponent icon={ReloadSvg} label="Reset" type="button" outline disabled={loading} onClick={handleReset} />
                            <ButtonComponent icon={PlaySvg} label={loading ? "Generating..." : "Generate"} type="button" disabled={loading || isGlobalApiLoading} onClick={HandleGenerateReport} />
                        </ActionsContainer>
                    </ReportCatalogFiltersContainer>
                }
                {
                    states.selectedTab === ReportCatalogTabsConstant?.preview &&
                    <>
                        {
                            reportExportData && reportExportData?.length > 0 ? (
                                <TableWrapper>
                                    {
                                        reportExportData?.length > 100 &&
                                        <Alert severity="warning" sx={{ borderRadius: 0 }}>Preview mode — showing first 100 rows only.</Alert>
                                    }
                                    <TableComponent
                                        rows={reportExportData?.length > 100 ? reportExportData?.slice(0, 100) : reportExportData}
                                        columns={columns}
                                        // icon={HistorySvg}
                                        responsive={false}
                                    />
                                    <div style={{ padding: '10px' }}>
                                        <ActionsContainer>
                                            <ButtonComponent icon={SettingsSvg} label="Change filters" type="button" outline
                                                onClick={() => setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.filters }))}
                                            />
                                            <ButtonComponent icon={DownloadSvg} label={`Export ${form?.selectedFormat?.toUpperCase() || ''} now`} type="button" onClick={handleExportReport} />
                                        </ActionsContainer>
                                    </div>
                                </TableWrapper>
                            ) : (
                                <EmptyWrapper>
                                    <p>Please apply filters to search for data to export!</p>
                                    <AnchorButton onClick={() => setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.filters }))}>Apply now</AnchorButton>
                                </EmptyWrapper>
                            )
                        }
                    </>
                }
                {
                    states.selectedTab === ReportCatalogTabsConstant?.exports &&
                    <>
                        {
                            history && history?.length > 0 ? (
                                <TableWrapper>
                                    <TableComponent
                                        rows={history}
                                        columns={historyColumns}
                                        // icon={HistorySvg}
                                        responsive={false}
                                    />
                                </TableWrapper>
                            ) : (
                                <EmptyWrapper>
                                    <p>No export history found!</p>
                                    <AnchorButton onClick={() => setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.filters }))}>Export now</AnchorButton>
                                </EmptyWrapper>
                            )
                        }
                    </>
                }
            </>
        </TabsComponent>
    );
};

export default ParticipantManagementReportExport;